import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { Logo } from './Logo';
export function TopBar() {
  return <div className="bg-brand-brown-light/40 border-b border-brand-brown/10" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center md:justify-between gap-x-4 gap-y-1 text-sm" data-id="element-104">
        <a href="#" aria-label="Sestri za tačke - domov" className="flex items-center gap-2 font-bold text-brand-text" data-id="element-105">
          <Logo size={32} data-id="element-106" />
          <span data-id="element-107">
            Sestri za <span className="text-brand-brown" data-id="element-108">tačke</span>
          </span>
        </a>
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-id="element-109">
          <a href="tel:+38640335549" className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-pink-light hover:bg-brand-pink text-brand-text font-medium transition-colors" aria-label="Pokliči Eli" data-id="element-110">
            <Phone className="w-3.5 h-3.5" data-id="element-111" />
            <span data-id="element-112">040 335 549 · Eli</span>
          </a>
          <a href="tel:+38640334347" className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-green-light hover:bg-brand-green text-brand-text font-medium transition-colors" aria-label="Pokliči Ema" data-id="element-113">
            <Phone className="w-3.5 h-3.5" data-id="element-114" />
            <span data-id="element-115">040 334 347 · Ema</span>
          </a>
          <a href="mailto:sestrizatacke@siter.si" className="hidden sm:flex items-center gap-1.5 px-3 py-1 rounded-full hover:bg-white/60 text-brand-text/80 font-medium transition-colors" aria-label="Pošlji e-pošto" data-id="element-116">
            <Mail className="w-3.5 h-3.5" data-id="element-117" />
            <span data-id="element-118">sestrizatacke@siter.si</span>
          </a>
        </div>
      </div>
    </div>;
}